export var STATUS_ENUM;
(function (STATUS_ENUM) {
    STATUS_ENUM["IDLE"] = "idle";
    STATUS_ENUM["PENDING"] = "pending";
    STATUS_ENUM["SUCCESS"] = "success";
    STATUS_ENUM["ERROR"] = "error";
})(STATUS_ENUM || (STATUS_ENUM = {}));
